const SENSITIVE_KEYS = new Set([
  'password',
  'passwordConfirmation',
  'token',
  'accessToken',
  'refreshToken',
  'apiKey',
  'secret',
  'authorization',
  'cookie',
]);

const LARGE_PAYLOAD_KEYS = new Set([
  'content',
  'body',
  'document',
  'html',
  'markdown',
]);

const MAX_STRING_LENGTH = 500;

type LogContext = Record<string, unknown>;

export function sanitizeLogContext(context: LogContext): LogContext {
  const result: LogContext = {};

  for (const [key, value] of Object.entries(context)) {
    if (SENSITIVE_KEYS.has(key)) {
      result[key] = '********';
    } else if (LARGE_PAYLOAD_KEYS.has(key) && typeof value === 'string') {
      result[key] = `[truncated ${value.length} chars]`;
    } else if (typeof value === 'string' && value.length > MAX_STRING_LENGTH) {
      result[key] = `[truncated ${value.length} chars]`;
    } else if (isPlainObject(value)) {
      result[key] = sanitizeLogContext(value as LogContext);
    } else {
      result[key] = value;
    }
  }

  return result;
}

function isPlainObject(value: unknown): boolean {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
